import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { usePermissionsStore } from "@/shared/store/permissions_store";
import { useLoginStore } from "@/modules/login/store/login_store";
import { clearClientSession } from "@/shared/services/session_service";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Login",
    component: () => import("@/modules/login/ui/views/LoginView.vue"),
    meta: {
      requiresAuth: false,
    },
    alias: "/login",
  },
  {
    path: "/financiamentos",
    name: "Financiamentos",
    component: () =>
      import("@/modules/financiamentos/views/FinanciamentosView.vue"),
    meta: {
      title: "Financiamentos",
      requiresAuth: true,
      permission: 118,
    },
  },
  {
    path: "/backoffice-comercial",
    name: "BackofficeComercial",
    component: () =>
      import(
        "@/modules/backoffice_comercial/views/BackofficeComercialView.vue"
      ),
    meta: {
      title: "Backoffice Comercial",
      requiresAuth: true,
      permission: 119,
    },
  },
  {
    path: "/financiamentos-reprovados",
    name: "FinanciamentosReprovados",
    component: () =>
      import(
        "@/modules/financiamentos_reprovados/views/FinanciamentosReprovadosView.vue"
      ),
    meta: {
      title: "Financiamentos Reprovados",
      requiresAuth: true,
      permission: 119,
    },
  },
  {
    path: "/backoffice-engenharia",
    name: "BackofficeEngenharia",
    component: () =>
      import(
        "@/modules/backoffice_engenharia/views/BackofficeEngenhariaView.vue"
      ),
    meta: {
      title: "Backoffice Engenharia",
      requiresAuth: true,
      permission: 120,
    },
  },
  {
    path: "/detalhes-proposta/:id/:personTypeId/:processStepId",
    name: "DetalhesProposta",
    component: () =>
      import("@/modules/detalhes_proposta/views/DetalhesProposta.vue"),
    props: true,
    meta: {
      title: "Detalhes da Proposta",
      requiresAuth: false,
    },
  },
  {
    path: "/integrador/detalhes-proposta/:id/analise-documentacao",
    name: "IntegradorAnaliseDocumentacao",
    component: () =>
      import(
        "@/modules/detalhes_proposta/views/IntegradorAnaliseDocumentacaoView.vue"
      ),
    props: true,
    meta: {
      title: "Análise da Documentação",
      requiresAuth: true,
    },
  },
  {
    path: "/integrador/faturamento/analise",
    name: "IntegradorAnaliseFaturamento",
    component: () =>
      import("@/modules/telas_analise/views/AnaliseFaturamento.vue"),
    meta: {
      title: "Análise de Faturamento",
      requiresAuth: true,
    },
  },
  {
    path: "/integrador/implantacao/analise",
    name: "IntegradorAnaliseImplantacao",
    component: () =>
      import("@/modules/telas_analise/views/AnaliseImplantação.vue"),
    meta: {
      title: "Análise de Implantação",
      requiresAuth: true,
    },
  },
  {
    path: "/backoffice-engenharia/detalhes-proposta/:id/analise-documentacao",
    name: "BackofficeEngenhariaAnaliseDocumentacao",
    component: () =>
      import(
        "@/modules/backoffice_engenharia/views/BackofficeEngenhariaProposta.vue"
      ),
    props: true,
    meta: {
      title: "Análise de Documentação",
      requiresAuth: true,
      permission: 120,
      profileSlug: "BackOffice-Engenharia",
    },
  },
  {
    path: "/backoffice-engenharia/detalhes-proposta/:id/confirmacao-documentacao",
    name: "BackofficeEngenhariaConfirmacaoDocumentacao",
    component: () =>
      import(
        "@/modules/backoffice_engenharia/views/BackofficeEngenhariaProposta.vue"
      ),
    props: true,
    meta: {
      title: "Confirmação da Documentação",
      requiresAuth: true,
      permission: 120,
      profileSlug: "BackOffice-Engenharia",
    },
  },
  {
    path: "/backoffice-engenharia/detalhes-proposta/:id/analise-implantacao",
    name: "BackofficeEngenhariaAnaliseImplantacao",
    component: () =>
      import(
        "@/modules/backoffice_engenharia/views/BackofficeEngenhariaProposta.vue"
      ),
    props: true,
    meta: {
      title: "Análise de Implantação",
      requiresAuth: true,
      permission: 120,
      profileSlug: "BackOffice-Engenharia",
    },
  },
  {
    path: "/auth/cadastro",
    name: "CadastroUsuario",
    component: () => import("@/modules/users/ui/CadastroUsuarioView.vue"),
    meta: {
      title: "Cadastro de Usuário",
      requiresAuth: false,
    },
  },
  {
    path: "/auth/recadastro",
    name: "EsqueciSenha",
    component: () => import("@/modules/users/ui/ResetSenhaView.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/integrador/cadastro",
    name: "CadastroIntegrador",
    component: () =>
      import(
        "@/modules/integratorRegistration/ui/IntegratorRegistrationView.vue"
      ),
    meta: {
      title: "Cadastro de Integrador",
      requiresAuth: false,
    },
  },
  // {
  //   path: "/contrato",
  //   name: "Contrato",
  //   component: () => import("@/modules/Contrato/views/ContratoView.vue"),
  //   meta: {
  //     title: "Contrato",
  //   },
  // },
  {
    path: "/nova-proposta",
    name: "NovaProposta",
    component: () => import("@/modules/novaProposta/ui/NovaPropostaView.vue"),
    meta: {
      requiresAuth: true,
      title: "Simulação",
      permission: 128,
    },
  },
  {
    path: "/faturamento",
    name: "Faturamento",
    component: () => import("@/modules/Faturamento/views/FaturamentoView.vue"),
    meta: {
      title: "Faturamento",
      requiresAuth: true,
    },
  },
  // {
  //   path: "/analise_faturamento",
  //   name: "AnaliseFaturamento",
  //   component: () =>
  //     import("@/modules/backoffice_financeiro/view/BackofficeFinanceiro.vue"),
  //   meta: {
  //     title: "Análise de Faturamento",
  //     requiresAuth: true,
  //     permission: 118,
  //   },
  // },
  {
    path: "/backoffice-financeiro/detalhes-proposta/:id/analise-faturamento",
    name: "BackofficeFinanceiroAnaliseFaturamento",
    component: () =>
      import("@/modules/backoffice_financeiro/view/BackofficeFinanceiro.vue"),
    meta: {
      title: "Análise de Faturamento",
      requiresAuth: true,
      permission: 118,
    },
  },
  {
    path: "/analise_documentacao",
    name: "AnaliseDocumentacao",
    component: () =>
      import("@/modules/analise_documentacao/view/AnaliseDocumentacao.vue"),
    meta: {
      title: "Análise de Documentação",
      requiresAuth: true,
      permission: 120,
    },
  },
  {
    path: "/listagem_backoffice_financeiro",
    name: "BackofficeFinanceiro",
    component: () =>
      import(
        "@/modules/backoffice_financeiro_list/views/BackofficeFinanceiroListView.vue"
      ),
    meta: {
      title: "Backoffice Financeiro",
      requiresAuth: true,
      permission: 118,
    },
  },
  {
    path: "/desembolso",
    name: "Desembolso",
    component: () => import("@/modules/desembolso/view/desembolsoView.vue"),
    meta: {
      title: "Desembolso",
      requiresAuth: true,
      permission: 118,
    },
  },
  {
    path: "/documentacao_reprovada",
    name: "documentacao",
    component: () =>
      import("@/modules/telas_reprovacoes/views/DocumentacaoReprovadaView.vue"),
    meta: {
      title: "Documentação",
      requiresAuth: true,
      permission: 118,
    },
  },
  {
    path: "/faturamento_reprovado",
    name: "faturamento",
    component: () =>
      import("@/modules/telas_reprovacoes/views/FaturamentoReprovado.vue"),
    meta: {
      title: "Faturamento - 0005",
      requiresAuth: true,
      permission: 118,
    },
  },
  {
    path: "/implantacao_reprovado",
    name: "implantacao",
    component: () =>
      import("@/modules/telas_reprovacoes/views/ImplantacaoReprovado.vue"),
    meta: {
      title: "Implantação",
      requiresAuth: true,
      permission: 118,
    },
  },
  {
    path: "/proposta_reprovada",
    name: "proposta",
    component: () =>
      import("@/modules/telas_reprovacoes/views/PropostaReprovada.vue"),
    meta: {
      title: "Proposta",
      requiresAuth: true,
      permission: 118,
    },
  },
  {
    path: "/Meus_Dados",
    name: "MeusDados",
    component: () => import("@/modules/meus_dados/view/MeusDados.vue"),
    meta: {
      title: "Meus Dados",
    },
  },
  {
    path: "/documentacao_analise",
    name: "documentacao_analise",
    component: () =>
      import("@/modules/telas_analise/views/AnaliseDocumentacao.vue"),
    meta: {
      title: "Documentação",
      requiresAuth: true,
      permission: 118,
    },
  },
  {
    path: "/implantacao_analise",
    name: "implantacao_analise",
    component: () =>
      import("@/modules/telas_analise/views/AnaliseImplantação.vue"),
    meta: {
      title: "Implantação",
      requiresAuth: true,
      permission: 118,
    },
  },
  {
    path: "/faturamento_analise",
    name: "faturamento_analise",
    component: () =>
      import("@/modules/telas_analise/views/AnaliseFaturamento.vue"),
    meta: {
      title: "Faturamento",
      requiresAuth: true,
      permission: 118,
    },
  },
  {
    path: "/financiamento_concluido",
    name: "financiamento_concluido",
    component: () =>
      import(
        "@/modules/financiamento_concluido/view/financiamento_concluido.vue"
      ),
    meta: {
      title: "Monitoramento",
      requiresAuth: true,
      permission: 118,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuth = !!sessionStorage.getItem("access_token");
  const storePermissions = usePermissionsStore();
  const loginStore = useLoginStore();
  const myPermissions = storePermissions.permissions;
  const profileSlug = loginStore.authUser?.data?.profileSlug ?? "";

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiredPermission = to.meta.permission as number | undefined;
  const requiredProfileSlug = to.meta.profileSlug as string | undefined;

  // Verificar se o perfil tem acesso à rota baseado no profileSlug
  const hasProfileAccess = (routeName: string): boolean => {
    if (routeName === "financiamento_concluido") {
      return true;
    }

    switch (profileSlug) {
      case "Integrador":
      case "Adm-Integrador":
      case "Administrador":
        return routeName === "Financiamentos" || routeName === "MeusDados";

      case "BackOffice-Engenharia":
        return routeName === "BackofficeEngenharia";

      case "BackOffice-Comercial":
        return (
          routeName === "BackofficeComercial" ||
          routeName === "FinanciamentosReprovados"
        );

      case "BackOffice-Financeiro":
        return routeName === "BackofficeFinanceiro";

      default:
        return false;
    }
  };

  const findFirstAllowedRoute = () => {
    return router.getRoutes().find((route) => {
      const meta = route.meta as {
        requiresAuth?: boolean;
        permission?: number;
      };
      // Ignorar rotas com parâmetros dinâmicos
      if (route.path.includes(":")) return false;

      // Se a rota não requer autenticação, ignorar
      if (!meta?.requiresAuth) return false;

      // Se a rota requer autenticação mas não tem permissão específica, permitir
      if (!meta?.permission) return true;

      // Se tem permissão específica, verificar se o usuário tem essa permissão
      return myPermissions.some(
        (permission) => permission.id === meta.permission
      );
    })?.path;
  };

  if (requiresAuth && !isAuth) {
    return next({ name: "Login" });
  }

  if (isAuth && to.path === "/") {
    const fallbackPath = findFirstAllowedRoute();
    if (fallbackPath) {
      return next({ path: fallbackPath });
    }
    clearClientSession();
    return next({ name: "Login" });
  }

  if (
    requiresAuth &&
    requiredProfileSlug &&
    profileSlug !== requiredProfileSlug
  ) {
    const fallbackPath = findFirstAllowedRoute();
    if (fallbackPath) {
      return next({ path: fallbackPath });
    }
    clearClientSession();
    return next({ name: "Login" });
  }

  if (requiresAuth && requiredPermission) {
    // Verificar primeiro se o perfil tem acesso
    if (to.name && hasProfileAccess(to.name as string)) {
      return next();
    }

    // Se não, verificar permissão
    const hasPermission = myPermissions.some(
      (permission) => permission.id === requiredPermission
    );
    if (!hasPermission) {
      const fallbackPath = findFirstAllowedRoute();
      if (fallbackPath) {
        return next({ path: fallbackPath });
      }
      clearClientSession();
      return next({ name: "Login" });
    }
  }

  return next();
});

export default router;
